var _circle, _circle2, _circle3, _circle4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAgeRestricted = function SvgAgeRestricted(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "#fee658"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "url(#a)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    stroke: "#fff",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 120,
    height: 120,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "#6b0707"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 44,
    fill: "#ff6a6a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M55.2578 81.0002H34.5352l-4.0352-4 11.0078-8.1289c1.4453-1.5104 2.5651-2.7213 3.3594-3.6328.8073-.9114 1.3737-1.6862 1.6992-2.3242s.4883-1.3021.4883-1.9922c0-.8464-.2735-1.4583-.8203-1.8359-.5469-.3776-1.1914-.5664-1.9336-.5664-.8985 0-1.8099.2604-2.7344.7812-.9115.5078-1.9466 1.263-3.1055 2.2656l-3.9969-3.9964-.2413-.9645c.8593-.7682 1.7708-1.4974 2.7343-2.1875.9636-.7031 2.1029-1.276 3.418-1.7188 1.3151-.4427 2.9167-.664 4.8047-.664 1.9401 0 2.0143-2.0052 3.4336-1.3281 0 0 3.354 3.3478 4.0156 4.0157.341.3443.6444.718.9102 1.121.7812 1.1719 1.1718 2.5065 1.1718 4.0039 0 1.6536-.306 3.1315-.9179 4.4336-.599 1.289-1.5039 2.5846-2.7149 3.8867-1.2109 1.2891-2.7213 2.7539-4.5312 4.3945l-2.0899 1.875v.1953l6.803-4 3.9978 4zM75.1797 81.0002h-7.832l-3.9977-4 3.9977-10.1211v-1.4257c0-.7032.0065-1.4779.0195-2.3243.026-.8463.0586-1.608.0976-2.2851-.3385.4036-.6575.7487-.957 1.0351-.2864.2865-.5664.5534-.8398.8008l-3.2422 2.6758-3.9958-3.9954 9.7966-8.9148 2.9554-3.9953 3.9977 3.9953zM94.5352 64.2815l3.2848-4.0013 4 4.0013v5.2344h-7.2848v7.0507h-5.2344L85.3 72.5702l4.0008-3.0543h-7.2852L78.02 65.5162l11.2808-1.2347L90.54 53.1102l3.9952 4.0033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.2578 77H30.5352v-5.0781l6.9726-7.0508c1.4453-1.5104 2.5651-2.7214 3.3594-3.6328.8073-.9115 1.3737-1.6862 1.6992-2.3242.3255-.6381.4883-1.3021.4883-1.9922 0-.8464-.2735-1.4584-.8203-1.836-.5469-.3776-1.1914-.5664-1.9336-.5664-.8985 0-1.8099.2604-2.7344.7813-.9115.5078-1.9466 1.263-3.1055 2.2656l-4.2382-4.9609c.8593-.7683 1.7708-1.4974 2.7343-2.1875.9636-.7032 2.1029-1.2761 3.418-1.7188s2.9167-.664 4.8047-.664c1.9401 0 3.6198.3385 5.0391 1.0156 1.4322.6771 2.539 1.6081 3.3203 2.793.7812 1.1718 1.1718 2.5065 1.1718 4.0039 0 1.6536-.306 3.1315-.9179 4.4335-.599 1.2891-1.5039 2.5847-2.7149 3.8868-1.2109 1.289-2.7213 2.7539-4.5312 4.3945l-2.0899 1.875v.1953h10.8008zM71.1797 77h-7.832V61.4531c0-.7031.0065-1.4778.0195-2.3242.026-.8463.0586-1.6081.0976-2.2851-.3385.4036-.6575.7486-.957 1.0351-.2864.2865-.5664.5534-.8398.8008l-3.2422 2.6758-4.0039-4.9219 9.8047-7.9883h6.9531zM90.5352 60.2812h7.2851v5.2344h-7.2851v7.0508h-5.2344v-7.0508h-7.2852v-5.2344h7.2852v-7.1679h5.2344z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4,
    x2: 124,
    y1: 4,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbe6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdb4d",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAgeRestricted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "age-restricted.cf732405d2070aa17e42107faed57dbf.svg";